export default "__VITE_PUBLIC_ASSET__4628f87a__"